import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

export interface WlmEmptyStateProps {
  icon: LucideIcon;
  message: string;
  hint?: ReactNode;
}

/** Shared centered empty state (icon + message + optional hint) for WLM lists. */
export function WlmEmptyState({ icon: Icon, message, hint }: WlmEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <Icon
        className="h-10 w-10 text-gray-400 dark:text-gray-500"
        aria-hidden="true"
      />
      <p className="mt-3 text-sm font-medium text-gray-700 dark:text-gray-200">{message}</p>
      {hint && <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{hint}</p>}
    </div>
  );
}
